import "./Media2025.scss";
import React, { useState } from "react";
import Header from "../../Shared/header/Header";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ceremonyVideo from "../../assets/video/SPEAwards-Ceremony-2025.mp4";

export const Media2025 = () => {
  const [pictures, setPictures] = useState([]);

  const [videos, setVideos] = useState([ceremonyVideo]);

  return (
    <>
      <Header />
      <div className="media-container">
        <Tabs className="tabs">
          <TabList>
            <Tab>Pictures</Tab>
            <Tab>Videos</Tab>
          </TabList>

          <TabPanel className="picture">
            {pictures.length === 0 ? (
              <div className="coming-soon">Coming soon</div>
            ) : (
              pictures.map((elm, index) => (
                <Zoom key={index}>
                  <div className="media-item">
                    <img src={elm} alt="" />
                  </div>
                </Zoom>
              ))
            )}
          </TabPanel>
          <TabPanel className="picture">
            {videos.map((elm, index) => {
              return (
                <div key={index} className="media-item">
                  <video width="100%" height="100%" controls src={elm} />
                </div>
              );
            })}
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};
